import { css } from 'styled-components';
var styles = css([".nva-yrt__root{> :first-child{margin-top:0;}> :last-child{margin-bottom:0;}}li{color:var(--sc-font-color-p,", ");}"], function (props) {
  var _props$theme;
  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.fontColorP;
});
export default styles;